import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  Panel,
  Dropdown,
  IconButton,
  Button,
  Calendar,
  Modal,
  Placeholder,
  DatePicker,
  Table,
  Stack,
  Heading,
  ButtonGroup,
  Whisper,
  Popover,
  Tooltip,
  List,
  Avatar,
  TagPicker,
  ButtonToolbar,
  Tag,
  Form,
  Loader,
  DOMHelper,
  Pagination,
  useToaster
} from 'rsuite';
import {
  AiOutlineCalendar,
  AiOutlineHome,
  AiOutlineOffice,
  AiOutlineQuestion
} from 'react-icons/ai';
import { ArrowLeftLine, ArrowRightLine, CalenderSimple, Edit, Icon } from '@rsuite/icons';
import { format, isEqual, isSameDay, isToday, isWeekend, startOfDay } from 'date-fns';
import {
  RiCalendarCloseFill,
  RiCalendarCloseLine,
  RiHomeOfficeLine,
  RiUserLocationFill,
  RiUserLocationLine
} from 'react-icons/ri';
import { HiOutlineBuildingOffice } from 'react-icons/hi2';
import { GrMapLocation } from 'react-icons/gr';
import { ImageCell } from '../members/Cells';
import { FaHome, FaBuilding, FaCalendar, FaTimes } from 'react-icons/fa';
import { LuCalendarDays } from 'react-icons/lu';
import { BsSuitcase, BsSuitcaseFill } from 'react-icons/bs';
import { IoHomeOutline } from 'react-icons/io5';
import { FaCalendarXmark } from 'react-icons/fa6';
import { LiaSearchLocationSolid } from 'react-icons/lia';
import { FaQuestion } from 'react-icons/fa6';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import MoreIcon from '@rsuite/icons/legacy/More';
import { useAppDispatch, useAppSelector } from '@/config/hooks';
import { getAdminUsers } from '@/services/user.service';
import { getServicelines } from '@/services/serviceline.service';
import { getOperationsByDepartments, getOperationsByUsers } from '@/services/operation.service';
import ConfirmModal from '@/components/ConfirmModal';
import { useNavigate } from 'react-router-dom';
import calendarImage from '@/images/Calendar.svg';
import { useTranslation } from 'react-i18next';

const { Column, HeaderCell, Cell } = Table;
const { getHeight } = DOMHelper;

const generateWeek = date => {
  const start = new Date(date);

  const dayOfWeek = start.getDay();
  const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
  start.setDate(date.getDate() - daysToSubtract);

  return Array.from({ length: 7 }, (_, i) => {
    const day = new Date(start);
    day.setDate(start.getDate() + i);
    return day;
  });
};

function Schedule() {
  const toaster = useToaster();
  const navigate = useNavigate();

  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedWeek, setSelectedWeek] = useState(generateWeek(new Date()));

  const [data, setData] = useState(null);
  const [filtred, setFiltred] = useState([]);
  const [modes, setModes] = useState([]);

  const [limit, setLimit] = React.useState(20);
  const [page, setPage] = React.useState(1);

  const handleChangeLimit = dataKey => {
    setPage(1);
    setLimit(dataKey);
  };

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [selectedModes, setSelectedModes] = useState([]);
  const [confirmModal, setConfirmModal] = useState<any>({
    open: false,
    title: '',
    subtitle: ''
  });

  const dispatch = useAppDispatch();

  const users = useAppSelector((state: any) => state.users.data);

  const loadingUsers = useAppSelector((state: any) => state.users.loading);
  const departments = useAppSelector((state: any) => state.serviceLine.data)?.map(item => {
    return { value: item._id, label: item.serviceLine };
  });

  const loadingDepartments = useAppSelector((state: any) => state.serviceLine.loading);

  const features = useAppSelector(state => state.feature.data);

  const loading = useAppSelector((state: any) => state.operation.loading);
  const operations = useAppSelector((state: any) => state.operation.data);

  useEffect(() => {
    const fetchData = async () => {
      dispatch(getAdminUsers());
      dispatch(getServicelines());
    };

    fetchData();
  }, []);

  useEffect(() => {
    const featuresArray: any = [];
    const addedFeatures = new Set();

    features?.forEach(project => {
      const featureName = project.name?.toLowerCase();

      if (featureName === 'on site' && !addedFeatures.has('on site')) {
        featuresArray.push({ label: 'On site', value: 'RESERVATION' });
        addedFeatures.add('on site');
      }

      if (featureName === 'wfh' && !addedFeatures.has('WFH')) {
        featuresArray.push(
          { label: 'WFH', value: 'WFH' },
          { label: 'Exceptional WFH', value: 'REMOTE_WORKING' }
        );
        addedFeatures.add('WFH');
      }

      if (featureName === 'leave' && !addedFeatures.has('Leave')) {
        featuresArray.push({ label: 'Leave', value: 'Leave' });
        addedFeatures.add('Leave');
      }

      if (featureName === 'third party site' && !addedFeatures.has('Third party site')) {
        featuresArray.push({ label: 'Third party site', value: 'Client site' });
        addedFeatures.add('Third party site');
      }

      if (featureName === 'travel' && !addedFeatures.has('travel')) {
        featuresArray.push({ label: 'Business Travel', value: 'TRAVEL' });
        addedFeatures.add('travel');
      }
    });

    if (JSON.stringify(modes) !== JSON.stringify(featuresArray)) {
      setModes(featuresArray);
    }
  }, [features, modes]);

  const handleDateSelect = date => {
    const week = generateWeek(date);
    setSelectedWeek(week);
    setShowCalendar(false);
  };

  //   useEffect(() => {
  //     // if (users.length > 0) {
  //     //   const startDate = selectedWeek[0];
  //     //   const endDate = selectedWeek[selectedWeek.length - 1];
  //     //   const ids = Array.from(users, ({ _id }) => _id);
  //     //   dispatch(
  //     //     getOperationsByUsers(ids, format(startDate, 'yyyy-MM-dd'), format(endDate, 'yyyy-MM-dd'))
  //     //   );
  //     // }
  //   }, [selectedWeek, users]);

  useEffect(() => {
    if (selectedUsers.length > 0) {
      const startDate = selectedWeek[0];
      const endDate = selectedWeek[selectedWeek.length - 1];
      //   const ids = Array.from(
      //     users.filter(item => selectedUsers.includes(item._id)),
      //     ({ _id }) => _id
      //   );
      //   console.log('ids', ids);
      dispatch(
        getOperationsByUsers(
          selectedUsers,
          format(startDate, 'yyyy-MM-dd'),
          format(endDate, 'yyyy-MM-dd')
        )
      );
    }

    if (selectedDepartments.length > 0) {
      const startDate = selectedWeek[0];
      const endDate = selectedWeek[selectedWeek.length - 1];
      dispatch(
        getOperationsByDepartments(
          selectedDepartments,
          format(startDate, 'yyyy-MM-dd'),
          format(endDate, 'yyyy-MM-dd')
        )
      );
    }
  }, [selectedWeek, selectedUsers, selectedDepartments]);

  useEffect(() => {
    const usersOperations = Array.from(operations, ({ user }) => user);
    console.log('usersOperations', usersOperations);
    const usersMap = usersOperations.reduce((acc, user) => {
      console.log('user', user);
      if (user) {
        acc[user._id] = {
          _id: user._id,
          name: `${user.firstname} ${user.lastname}`,
          department: user.serviceLine,
          photo: user.photo,
          schedule: []
        };
      }
      return acc;
    }, {});

    const getDateRange = (startDate, endDate) => {
      const dates = [];
      let current = new Date(startDate);
      const last = new Date(endDate);

      while (current <= last) {
        dates.push(current.toISOString().split('T')[0]);
        current.setDate(current.getDate() + 1);
      }

      return dates;
    };

    operations.forEach(op => {
      const userId = op.user?._id;
      if (!usersMap[userId]) return;

      let operationDates: any = [];
      const slotsByDate: any = {};

      if (op.date) {
        operationDates = [op.date.split('T')[0]];
        slotsByDate[operationDates[0]] = [op.timeslot];
      } else if (op.reservationdate) {
        operationDates = [op.reservationdate.split('T')[0]];
        slotsByDate[operationDates[0]] = [op.timeslot];
      } else if (op.date_debut && op.date_fin) {
        operationDates = getDateRange(op.date_debut, op.date_fin);

        operationDates.forEach((date, index) => {
          if (isSameDay(new Date(date), new Date(op.date_debut))) {
            slotsByDate[date] = op.slot_debut === 'PM' ? ['PM'] : ['AM', 'PM'];
          } else if (isSameDay(new Date(date), new Date(op.date_fin))) {
            slotsByDate[date] = op.slot_fin === 'AM' ? ['AM'] : ['AM', 'PM'];
          } else {
            slotsByDate[date] = ['AM', 'PM'];
          }
        });
      }

      operationDates.forEach(date => {
        slotsByDate[date].forEach(slot => {
          usersMap[userId].schedule.push({
            OperationType: op.OperationType,
            status: op.request?.status ? op.request?.status : op.status,
            slot,
            date,
            request: op.request,
            desk: op.desk,
            startDate: op.date_debut,
            endDate: op.date_fin,
            startSlot: op.slot_debut,
            endSlot: op.slot_fin
          });
        });
      });
    });

    setData(Object.values(usersMap));
    setFiltred(Object.values(usersMap));
  }, [operations]);

  const icons = {
    WFH: <FaHome />,
    RESERVATION: <FaBuilding />,
    Leave: <RiCalendarCloseFill />,
    'Client site': <RiUserLocationFill />,
    TRAVEL: <BsSuitcaseFill />,
    undeclared: <FaQuestion />,
    none: <FaTimes />,
    REMOTE_WORKING: <FaHome />
  };

  const handleChangeMembers = selectedTags => {
    if (selectedTags.includes('all')) {
      setSelectedUsers([...Array.from(users, ({ _id }) => _id), 'all']);
    }
    // else if (selectedTags.length == users.length && !selectedTags.includes('all')) {
    //   setSelectedUsers([]);
    // }
    else {
      setSelectedUsers(selectedTags);
    }
    setSelectedDepartments([]);
  };

  const handleChangeDepartments = value => {
    setSelectedUsers([]);
    setSelectedDepartments(value);
  };
  const handleChangeModes = value => setSelectedModes(value);

  //   useEffect(() => {
  //     console.log('selectedUsers', selectedUsers);
  //     if (selectedUsers.length == 0) {
  //       setFiltred(data);
  //     } else {
  //       const filteredData = data.filter(item => selectedUsers.includes(item._id));
  //       setFiltred(filteredData);
  //     }

  //     // const filteredData = data.map(user => ({
  //     //     ...user,
  //     //     schedule: user.schedule.filter(op =>
  //     //       selectedWorkModes.length === 0 || selectedWorkModes.includes(op.OperationType)
  //     //     )
  //     //   })).filter(user => user.schedule.length > 0)
  //   }, [selectedUsers]);

  const filteredData = useMemo(() => {
    if (!data) return null;
    return data?.filter((item: any) => {
      //   if (selectedUsers.length > 0 && !selectedUsers.includes(item._id)) return false;

      //   if (selectedDepartments.length > 0 && !selectedDepartments.includes(item.department?._id))
      //     return false;

      if (selectedModes.length > 0) {
        const workModeInSchedule = item.schedule.some(scheduleItem =>
          selectedModes.includes(scheduleItem.OperationType)
        );
        if (!workModeInSchedule) return false;
      }
      return true;
    });
  }, [data, selectedModes]);

  const handleNextWeek = () => {
    const nextMonday = new Date(selectedWeek[selectedWeek.length - 1]);
    nextMonday.setDate(nextMonday.getDate() + 7);
    setSelectedWeek(generateWeek(nextMonday));
  };

  const handlePrevWeek = () => {
    const prevSunday = new Date(selectedWeek[0]);
    prevSunday.setDate(prevSunday.getDate() - 7);
    setSelectedWeek(generateWeek(prevSunday));
  };

  const getScheduleInfo = (schedule, date, slot) => {
    return schedule.find(
      item =>
        isEqual(startOfDay(new Date(item.date)), startOfDay(new Date(date))) && item.slot === slot
    );
  };

  const getStatusColor = status => {
    if (status === 'ACTIVE' || status === 'pending') return 'orange';
    if (status === 'ENDED' || status === 'CLOSED' || status === 'accepted') return 'green';
    return 'gray';
  };

  const getOperationLabel = operationType => {
    const labels = {
      RESERVATION: 'On Site',
      ACTIVE: 'Booked',
      ENDED: 'Checked-In',
      CLOSED: 'Checked-Out',
      REMOTE_WORKING: 'Exceptional WFH',
      'Client site': 'Third Party Site',
      TRAVEL: 'Business Travel'
    };
    return labels[operationType] || operationType;
  };

  //   const handleDelete = async id => {
  //     try {
  //       console.log('delete id', id);
  //     } catch (error) {
  //       toaster.push(
  //         <Message type="error" duration={5000} showIcon>
  //           {error.message}
  //         </Message>,
  //         { placement: 'topCenter' }
  //       );
  //     }
  //     setConfirmModal({ open: false });
  //   };

  const isFutureOrToday = date => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const operationDate = new Date(date);
    operationDate.setHours(0, 0, 0, 0);

    return operationDate >= today;
  };
  const { t } = useTranslation();

  const renderSlot = (schedule, date, slot) => {
    const scheduleInfo = getScheduleInfo(schedule, date, slot);

    // console.log('scheduleInfo', scheduleInfo);

    if (!scheduleInfo && !isWeekend(new Date(date))) {
      return <IconButton size="sm" icon={<FaQuestion style={{ color: 'gray' }} />} circle />;
    }
    if (!scheduleInfo && isWeekend(new Date(date))) {
      return <IconButton size="sm" icon={<FaTimes style={{ color: 'red' }} />} circle />;
    }
    scheduleInfo && console.log('scheduleInfo', scheduleInfo);

    if (scheduleInfo.OperationType === 'RESERVATION') {
      return (
        <Whisper
          placement="top"
          controlId="control-id-focus"
          trigger="click"
          speaker={
            <Popover
              title={
                <Stack justifyContent="space-between">
                  {getOperationLabel(scheduleInfo.OperationType)}
                  {/* {isFutureOrToday(date) && (
                    <IconButton
                      size="xs"
                      icon={<MdOutlineDeleteOutline color="red" />}
                      onClick={() => {
                        setConfirmModal({
                          open: true,
                          title: 'Are you sure to remove this operation ?',
                          subtitle: 'You cannot undo this operation',
                          onConfirm: () => {
                            handleDelete(scheduleInfo._id);
                          }
                        });
                      }}
                      id={`delete-${scheduleInfo._id}`}
                      circle
                    />
                  )}{' '} */}
                </Stack>
              }
            >
              <div style={{ padding: 10 }}>
                <p>
                  <strong>
                    {scheduleInfo?.desk?.zone?.floor?.name} | {scheduleInfo?.desk?.zone?.name} -{' '}
                    {scheduleInfo?.desk?.name}{' '}
                  </strong>
                </p>
                <Stack justifyContent="space-between" style={{ marginTop: 10 }}>
                  <Tag color={getStatusColor(scheduleInfo.status)} size="sm">
                    {getOperationLabel(scheduleInfo.status)}
                  </Tag>
                  <Whisper
                    placement="top"
                    controlId="control-id-focus"
                    trigger="hover"
                    speaker={<Tooltip>{t('Locate on map')}</Tooltip>}
                  >
                    <IconButton
                      size="sm"
                      icon={<LiaSearchLocationSolid size={15} />}
                      circle
                      onClick={() => {
                        const reservationData = {
                          desk: scheduleInfo?.desk?.name,
                          floorId: scheduleInfo?.desk?.zone?.floor?._id,
                          date: scheduleInfo.date,
                          slot: scheduleInfo.slot
                        };

                        navigate('/floor-maps', { state: reservationData });
                      }}
                    />
                  </Whisper>
                </Stack>
              </div>
            </Popover>
          }
        >
          <IconButton
            size="sm"
            icon={icons[scheduleInfo.OperationType]}
            circle
            style={{ color: getStatusColor(scheduleInfo.status) }}
          />
        </Whisper>
      );
    }

    return (
      <Whisper
        placement="top"
        controlId="control-id-focus"
        trigger="click"
        speaker={
          <Popover title={getOperationLabel(scheduleInfo.OperationType)}>
            <div style={{ padding: 10 }}>
              <p>
                <strong>{t('validator: ')}</strong>
                {scheduleInfo?.request?.idReciever?.firstname}{' '}
                {scheduleInfo?.request?.idReciever?.lastname}
              </p>

              {scheduleInfo?.startDate && scheduleInfo?.endDate && (
                <p>
                  <strong>Period: </strong>
                  {format(new Date(scheduleInfo?.startDate), 'dd-MM-yyyy')}{' '}
                  {scheduleInfo?.startSlot} -{' '}
                  {format(new Date(scheduleInfo?.endDate), 'dd-MM-yyyy')} {scheduleInfo?.endSlot}
                </p>
              )}
              {scheduleInfo.OperationType == 'Client site' && (
                <p>
                  <strong>Site: </strong>
                  {scheduleInfo?.request?.client}
                </p>
              )}
              {scheduleInfo?.request?.UserNotif?.length > 0 && (
                <p>
                  <strong>Users notified: </strong>
                  {scheduleInfo?.request?.UserNotif?.map((user, index) => (
                    <span key={index}>
                      {user.firstname} {user.lastname}
                    </span>
                  ))}
                </p>
              )}
            </div>
          </Popover>
        }
      >
        <IconButton
          size="sm"
          icon={icons[scheduleInfo.OperationType]}
          circle
          style={{ color: getStatusColor(scheduleInfo.status) }}
        />
      </Whisper>
    );
  };

  return (
    <div>
      <Panel
        bodyFill
        style={{ background: '#fff', padding: 20 }}
        header={
          <Stack justifyContent="space-between">
            <Form fluid>
              <Stack spacing={20}>
                <Form.Group>
                  <Form.ControlLabel style={{ fontSize: 13, fontWeight: 'normal' }}>
                    {t('Members')}
                  </Form.ControlLabel>
                  <TagPicker
                    data={[
                      //   { value: 'all', label: 'Select All' },
                      ...users.map(item => ({
                        value: item._id,
                        label: item.firstname + ' ' + item.lastname
                      }))
                    ]}
                    style={{ width: 225 }}
                    placeholder={t('Select members')}
                    loading={loadingUsers}
                    placement="auto"
                    value={selectedUsers}
                    onChange={handleChangeMembers}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.ControlLabel style={{ fontSize: 13, fontWeight: 'normal' }}>
                    {t('Teams')}
                  </Form.ControlLabel>
                  <TagPicker
                    data={departments}
                    style={{ width: 225 }}
                    placeholder={t('Select Teams')}
                    loading={loadingDepartments}
                    placement="auto"
                    value={selectedDepartments}
                    onChange={handleChangeDepartments}
                  />
                </Form.Group>
                {modes?.length > 0 && data.length > 0 && (
                  <Form.Group>
                    <Form.ControlLabel style={{ fontSize: 13, fontWeight: 'normal' }}>
                      {t('Work modes')}
                    </Form.ControlLabel>
                    <TagPicker
                      data={modes}
                      style={{ width: 225 }}
                      placeholder={t('Select modes')}
                      placement="auto"
                      value={selectedModes}
                      onChange={handleChangeModes}
                    />{' '}
                  </Form.Group>
                )}
              </Stack>
            </Form>
            <ButtonGroup>
              <IconButton icon={<ArrowLeftLine />} appearance="default" onClick={handlePrevWeek} />
              <Button onClick={() => setShowCalendar(true)}>
                <LuCalendarDays style={{ marginRight: 7 }} />
                {format(selectedWeek[0], 'EEE dd')} -{' '}
                {format(selectedWeek[selectedWeek.length - 1], 'EEE dd')}
              </Button>

              <IconButton icon={<ArrowRightLine />} appearance="default" onClick={handleNextWeek} />
            </ButtonGroup>
          </Stack>
        }
      >
        {selectedUsers?.length == 0 && selectedDepartments.length == 0 ? (
          <Stack justifyContent="center" direction="column" style={{ marginTop: 50 }} spacing={20}>
            <p>{t('Select users or teams to see their schedules.')}</p>
            <img src={calendarImage} width="100%" />
          </Stack>
        ) : (
          <Table
            height={Math.max(getHeight(window) - 250, 400)}
            data={filteredData}
            loading={loading}
            rowHeight={80}
            style={{ marginTop: 70 }}
          >
            <Column minWidth={200} flexGrow={1}>
              <HeaderCell></HeaderCell>
              <Cell>
                {employee => (
                  <Stack spacing={10} alignItems="center">
                    {employee.photo ? (
                      <Avatar
                        circle
                        src={process.env.REACT_APP_IMAGE_URL + employee.photo}
                        alt={employee.name}
                        size="sm"
                      />
                    ) : (
                      <Avatar circle size="sm" />
                    )}
                    <div>
                      <strong style={{ fontSize: 12 }}>{employee.name}</strong>
                      <br />
                      <small>{employee.department?.serviceLine}</small>
                    </div>
                  </Stack>
                )}
              </Cell>
            </Column>

            {selectedWeek.map((date, index) => {
              return (
                <Column width={120} key={index}>
                  <HeaderCell style={{ textAlign: 'center' }}>
                    {' '}
                    <strong key={index} style={{ fontSize: 12, color: 'var(--rs-text-primary)' }}>
                      {format(date, 'EEE').slice(0, 2)} {format(date, 'dd.MM')}
                    </strong>
                  </HeaderCell>
                  <Cell style={{ textAlign: 'center' }}>
                    {/* {employee => (
                    <div
                      key={index}
                      style={{
                        //   width: 120,

                        gap: 5,
                        textAlign: 'center'
                      }}
                    >
                      {!employee.schedule.find(
                        item =>
                          isEqual(startOfDay(new Date(item.date)), startOfDay(new Date(date))) &&
                          item.slot == 'AM'
                      ) && !isWeekend(new Date(date)) ? (
                        <IconButton
                          size="sm"
                          icon={<FaQuestion style={{ color: 'gray' }} />}
                          circle
                        />
                      ) : !employee.schedule.find(
                          item =>
                            isEqual(startOfDay(new Date(item.date)), startOfDay(new Date(date))) &&
                            item.slot == 'AM'
                        ) && isWeekend(new Date(date)) ? (
                        <IconButton size="sm" icon={<FaTimes style={{ color: 'red' }} />} circle />
                      ) : employee.schedule.find(
                          item =>
                            isEqual(startOfDay(new Date(item.date)), startOfDay(new Date(date))) &&
                            item.slot == 'AM'
                        )?.OperationType == 'RESERVATION' ? (
                        <Whisper
                          placement="top"
                          controlId="control-id-focus"
                          trigger="click"
                          speaker={
                            <Popover title="Floor 1 | E1-Z1 - Desk 25">
                              <Stack justifyContent="space-between">
                                <Tag
                                  color={
                                    employee.schedule.find(
                                      item =>
                                        isEqual(
                                          startOfDay(new Date(item.date)),
                                          startOfDay(new Date(date))
                                        ) && item.slot == 'AM'
                                    )?.status == 'ACTIVE'
                                      ? 'orange'
                                      : employee.schedule.find(
                                          item =>
                                            isEqual(
                                              startOfDay(new Date(item.date)),
                                              startOfDay(new Date(date))
                                            ) && item.slot == 'AM'
                                        )?.status == 'ENDED'
                                      ? 'green'
                                      : 'red'
                                  }
                                  size="sm"
                                >
                                  {employee.schedule.find(
                                    item =>
                                      isEqual(
                                        startOfDay(new Date(item.date)),
                                        startOfDay(new Date(date))
                                      ) && item.slot == 'AM'
                                  )?.status == 'ACTIVE'
                                    ? 'Booked'
                                    : employee.schedule.find(
                                        item =>
                                          isEqual(
                                            startOfDay(new Date(item.date)),
                                            startOfDay(new Date(date))
                                          ) && item.slot == 'AM'
                                      )?.status == 'ENDED'
                                    ? 'Checked-In'
                                    : 'Checked-Out'}
                                </Tag>
                                <Whisper
                                  placement="top"
                                  controlId="control-id-focus"
                                  trigger="hover"
                                  speaker={<Tooltip>Locate on map</Tooltip>}
                                >
                                  <IconButton size="sm" icon={<LiaSearchLocationSolid />} circle />
                                </Whisper>
                              </Stack>
                            </Popover>
                          }
                        >
                          <IconButton
                            //   key={idx}
                            size="sm"
                            icon={
                              icons[
                                employee.schedule.find(
                                  item =>
                                    isEqual(
                                      startOfDay(new Date(item.date)),
                                      startOfDay(new Date(date))
                                    ) && item.slot == 'AM'
                                )?.OperationType
                              ]
                            }
                            circle
                            style={{
                              color:
                                employee.schedule.find(
                                  item =>
                                    isEqual(
                                      startOfDay(new Date(item.date)),
                                      startOfDay(new Date(date))
                                    ) && item.slot == 'AM'
                                )?.status == 'ACTIVE'
                                  ? 'orange'
                                  : employee.schedule.find(
                                      item =>
                                        isEqual(
                                          startOfDay(new Date(item.date)),
                                          startOfDay(new Date(date))
                                        ) && item.slot == 'AM'
                                    )?.status == 'ENDED' ||
                                    employee.schedule.find(
                                      item =>
                                        isEqual(
                                          startOfDay(new Date(item.date)),
                                          startOfDay(new Date(date))
                                        ) && item.slot == 'AM'
                                    )?.status == 'CLOSEDs'
                                  ? 'green'
                                  : 'red'
                            }}
                          />
                        </Whisper>
                      ) : (
                        <Whisper
                          placement="top"
                          controlId="control-id-focus"
                          trigger="click"
                          speaker={
                            <Popover>
                              <strong>
                                {employee.schedule.find(
                                  item =>
                                    isEqual(
                                      startOfDay(new Date(item.date)),
                                      startOfDay(new Date(date))
                                    ) && item.slot == 'AM'
                                )?.OperationType == 'REMOTE_WORKING'
                                  ? 'Exceptional WFH'
                                  : employee.schedule.find(
                                      item =>
                                        isEqual(
                                          startOfDay(new Date(item.date)),
                                          startOfDay(new Date(date))
                                        ) && item.slot == 'AM'
                                    )?.OperationType == 'Client site'
                                  ? 'Third Party Site'
                                  : employee.schedule.find(
                                      item =>
                                        isEqual(
                                          startOfDay(new Date(item.date)),
                                          startOfDay(new Date(date))
                                        ) && item.slot == 'AM'
                                    )?.OperationType == 'TRAVEL'
                                  ? 'Business Travel'
                                  : employee.schedule.find(
                                      item =>
                                        isEqual(
                                          startOfDay(new Date(item.date)),
                                          startOfDay(new Date(date))
                                        ) && item.slot == 'AM'
                                    )?.OperationType}
                              </strong>
                            </Popover>
                          }
                        >
                          <IconButton
                            //   key={idx}
                            size="sm"
                            icon={
                              icons[
                                employee.schedule.find(
                                  item =>
                                    isEqual(
                                      startOfDay(new Date(item.date)),
                                      startOfDay(new Date(date))
                                    ) && item.slot == 'AM'
                                )?.OperationType
                              ]
                            }
                            circle
                            style={{
                              color:
                                employee.schedule.find(
                                  item =>
                                    isEqual(
                                      startOfDay(new Date(item.date)),
                                      startOfDay(new Date(date))
                                    ) && item.slot == 'AM'
                                ).status == 'pending'
                                  ? 'orange'
                                  : employee.schedule.find(
                                      item =>
                                        isEqual(
                                          startOfDay(new Date(item.date)),
                                          startOfDay(new Date(date))
                                        ) && item.slot == 'AM'
                                    ).status == 'accepted'
                                  ? 'green'
                                  : 'red'
                            }}
                          />
                        </Whisper>
                      )}

                      {!employee.schedule.find(
                        item =>
                          isEqual(startOfDay(new Date(item.date)), startOfDay(new Date(date))) &&
                          item.slot == 'PM'
                      ) && !isWeekend(new Date(date)) ? (
                        <IconButton
                          size="sm"
                          icon={<FaQuestion style={{ color: 'gray' }} />}
                          circle
                        />
                      ) : !employee.schedule.find(
                          item =>
                            isEqual(startOfDay(new Date(item.date)), startOfDay(new Date(date))) &&
                            item.slot == 'PM'
                        ) && isWeekend(new Date(date)) ? (
                        <IconButton size="sm" icon={<FaTimes style={{ color: 'red' }} />} circle />
                      ) : employee.schedule.find(
                          item =>
                            isEqual(startOfDay(new Date(item.date)), startOfDay(new Date(date))) &&
                            item.slot == 'PM'
                        ).OperationType == 'RESERVATION' ? (
                        <Whisper
                          placement="top"
                          controlId="control-id-focus"
                          trigger="click"
                          speaker={
                            <Popover title="Floor 1 | E1-Z1 - Desk 25">
                              <Stack justifyContent="space-between">
                                <Tag
                                  color={
                                    employee.schedule.find(
                                      item =>
                                        isEqual(
                                          startOfDay(new Date(item.date)),
                                          startOfDay(new Date(date))
                                        ) && item.slot == 'PM'
                                    )?.status == 'ACTIVE'
                                      ? 'orange'
                                      : employee.schedule.find(
                                          item =>
                                            isEqual(
                                              startOfDay(new Date(item.date)),
                                              startOfDay(new Date(date))
                                            ) && item.slot == 'PM'
                                        )?.status == 'ENDED' ||
                                        employee.schedule.find(
                                          item =>
                                            isEqual(
                                              startOfDay(new Date(item.date)),
                                              startOfDay(new Date(date))
                                            ) && item.slot == 'PM'
                                        )?.status == 'CLOSED'
                                      ? 'green'
                                      : 'red'
                                  }
                                  size="sm"
                                >
                                  {employee.schedule.find(
                                    item =>
                                      isEqual(
                                        startOfDay(new Date(item.date)),
                                        startOfDay(new Date(date))
                                      ) && item.slot == 'PM'
                                  )?.status == 'ACTIVE'
                                    ? 'Booked'
                                    : employee.schedule.find(
                                        item =>
                                          isEqual(
                                            startOfDay(new Date(item.date)),
                                            startOfDay(new Date(date))
                                          ) && item.slot == 'PM'
                                      )?.status == 'ENDED'
                                    ? 'Checked-In'
                                    : 'Checked-Out'}
                                </Tag>
                                <Whisper
                                  placement="top"
                                  controlId="control-id-focus"
                                  trigger="hover"
                                  speaker={<Tooltip>Locate on map</Tooltip>}
                                >
                                  <IconButton size="sm" icon={<LiaSearchLocationSolid />} circle />
                                </Whisper>
                              </Stack>
                            </Popover>
                          }
                        >
                          <IconButton
                            //   key={idx}
                            size="sm"
                            icon={
                              icons[
                                employee.schedule.find(
                                  item =>
                                    isEqual(
                                      startOfDay(new Date(item.date)),
                                      startOfDay(new Date(date))
                                    ) && item.slot == 'PM'
                                )?.OperationType
                              ]
                            }
                            circle
                            style={{
                              color:
                                employee.schedule.find(
                                  item =>
                                    isEqual(
                                      startOfDay(new Date(item.date)),
                                      startOfDay(new Date(date))
                                    ) && item.slot == 'PM'
                                )?.status == 'ACTIVE'
                                  ? 'orange'
                                  : employee.schedule.find(
                                      item =>
                                        isEqual(
                                          startOfDay(new Date(item.date)),
                                          startOfDay(new Date(date))
                                        ) && item.slot == 'PM'
                                    )?.status == 'ENDED' ||
                                    employee.schedule.find(
                                      item =>
                                        isEqual(
                                          startOfDay(new Date(item.date)),
                                          startOfDay(new Date(date))
                                        ) && item.slot == 'PM'
                                    )?.status == 'CLOSED'
                                  ? 'green'
                                  : 'red'
                            }}
                          />
                        </Whisper>
                      ) : (
                        <Whisper
                          placement="top"
                          controlId="control-id-focus"
                          trigger="click"
                          speaker={
                            <Popover>
                              <strong>
                                {employee.schedule.find(
                                  item =>
                                    isEqual(
                                      startOfDay(new Date(item.date)),
                                      startOfDay(new Date(date))
                                    ) && item.slot == 'PM'
                                )?.OperationType == 'REMOTE_WORKING'
                                  ? 'Exceptional WFH'
                                  : employee.schedule.find(
                                      item =>
                                        isEqual(
                                          startOfDay(new Date(item.date)),
                                          startOfDay(new Date(date))
                                        ) && item.slot == 'PM'
                                    )?.OperationType == 'Client site'
                                  ? 'Third Party Site'
                                  : employee.schedule.find(
                                      item =>
                                        isEqual(
                                          startOfDay(new Date(item.date)),
                                          startOfDay(new Date(date))
                                        ) && item.slot == 'PM'
                                    )?.OperationType == 'TRAVEL'
                                  ? 'Business Travel'
                                  : employee.schedule.find(
                                      item =>
                                        isEqual(
                                          startOfDay(new Date(item.date)),
                                          startOfDay(new Date(date))
                                        ) && item.slot == 'PM'
                                    )?.OperationType}
                              </strong>
                            </Popover>
                          }
                        >
                          <IconButton
                            //   key={idx}
                            size="sm"
                            icon={
                              icons[
                                employee.schedule.find(
                                  item =>
                                    isEqual(
                                      startOfDay(new Date(item.date)),
                                      startOfDay(new Date(date))
                                    ) && item.slot == 'PM'
                                )?.OperationType
                              ]
                            }
                            circle
                            style={{
                              color:
                                employee.schedule.find(
                                  item =>
                                    isEqual(
                                      startOfDay(new Date(item.date)),
                                      startOfDay(new Date(date))
                                    ) && item.slot == 'PM'
                                ).status == 'pending'
                                  ? 'orange'
                                  : employee.schedule.find(
                                      item =>
                                        isEqual(
                                          startOfDay(new Date(item.date)),
                                          startOfDay(new Date(date))
                                        ) && item.slot == 'PM'
                                    ).status == 'accepted'
                                  ? 'green'
                                  : 'red'
                            }}
                          />
                        </Whisper>
                      )}
                    </div>
                  )} */}

                    {employee => (
                      <div key={index} style={{ gap: 5, textAlign: 'center' }}>
                        {renderSlot(employee.schedule, date, 'AM')}
                        {renderSlot(employee.schedule, date, 'PM')}
                      </div>
                    )}
                  </Cell>
                </Column>
              );
            })}
          </Table>
        )}

        {/* <div style={{ padding: 20 }}>
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            maxButtons={5}
            size="xs"
            layout={['total', '-', 'limit', '|', 'pager', 'skip']}
            total={data?.length ? data?.length : 0}
            limitOptions={[10, 30, 50]}
            limit={limit}
            activePage={page}
            onChangePage={setPage}
            onChangeLimit={handleChangeLimit}
          />
        </div> */}
      </Panel>

      <Modal open={showCalendar} onClose={() => setShowCalendar(false)}>
        <Modal.Header>
          <Modal.Title>{t('Choose a Week')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Calendar
            // bordered
            onSelect={handleDateSelect}
            compact
            weekStart={1}
            showWeekNumbers={true}
            // style={{ width: 320 }}
          />
        </Modal.Body>
      </Modal>

      {confirmModal.open && (
        <ConfirmModal confirmDialog={confirmModal} setConfirmDialog={setConfirmModal} />
      )}
    </div>
  );
}

export default Schedule;
